import {
  EducatorsListingProfileItem,
  EducatorsReliefListingsPriorities,
  EducatorsReliefListingsReliefListingIndex,
} from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type NewProps = {
  priorities: Array<EducatorsReliefListingsPriorities>
}

export const useNewProps = () => useProps<NewProps>()

export type IndexProps = {
  listings: Array<{
    listing_profile: EducatorsListingProfileItem
    collection: Array<EducatorsReliefListingsReliefListingIndex>
  }>
}

export const useIndexProps = () => useProps<IndexProps>()
